import {
  Add_Sales,
  Delete_One_Sales,
  Get_All_Managers,
  Get_All_Sales,
  Get_All_Sales_By_Managers_Email_Type,
  Get_All_Sales_By_TeamLeader_Email,
  Get_All_Sales_For_Team_Leader_And_Teir_Leads,
  Get_All_Sales_Managers_By_Email,
  Get_All_Sales_Trash_type,
  Get_All_TeamLeaders_For_Managers_By_Email,
  Get_All_Top_Saler_by_Quarter,
  Get_Error,
  Get_One_Sales,
  Get_Sales_login_For_Assign_Leads_To_TeamLeaders_type,
  Update_One_Sales,
} from '../Types';

const initialState = {
  sales: [],
  salesTrash: [],

  salesupdate: [],
  salesforteamleaders: [],
  salesforManagers: [],
  TeamLeadersandsalesformanger: [],
  GetAllManagers: [],
  Get_All_Top_Saler_by_Quarter: [],
  Sales_For_Selected_teamLeader: [],
  sales_Assign_Leads_To_hisTeamLeader: [],
  loading: true,
  error: null,
};

const Sales_Reducers = (state = initialState, action) => {
  // console.log("🔥 Reducer Action:", action); // ✅ تحقق مما إذا كان الـ Reducer يُستدعى أم لا

  switch (action.type) {
    case Get_All_Sales:
      return {
        ...state,
        sales: action.payload || [], // ✅ تأكد أن البيانات ليست `undefined`
        loading: false,
      };
    case Add_Sales:
      return {
        ...state,
        // sales: [...state.sales, action.payload,action.status], // ✅ أضف العنصر الجديد بدلًا من الكتابة فوق `state`
        sales: action.payload,
        loading: false,
      };
    case Delete_One_Sales:
      return {
        ...state,
        sales: state.sales.filter((sale) => sale.id !== action.payload.id), // ✅ حذف العنصر بدلاً من الكتابة فوق `state`
        loading: false,
      };
    case Get_One_Sales:
      return {
        ...state,
        salesupdate: action.payload,
        loading: false,
      };
    case Update_One_Sales:
      return {
        ...state,
        salesupdate: action.payload,
        loading: false,
      };
    case Get_All_Sales_By_TeamLeader_Email:
      return {
        ...state,
        salesforteamleaders: action.payload || [],
        loading: false,
      };
    case Get_All_Sales_By_Managers_Email_Type:
      return {
        ...state,
        salesforManagers: action.payload || [],
        loading: false,
      };
    case Get_All_TeamLeaders_For_Managers_By_Email:
      return {
        ...state,
        TeamLeadersandsalesformanger: action.payload || [],
        loading: false,
      };
    case Get_All_Managers:
      return {
        ...state,
        GetAllManagers: action.payload || [],
        loading: false,
      };
    case Get_All_Top_Saler_by_Quarter:
      return {
        ...state,
        Get_All_Top_Saler_by_Quarter: action.payload || [],
        loading: false,
      };
    case Get_All_Sales_For_Team_Leader_And_Teir_Leads:
      return {
        ...state,
        Sales_For_Selected_teamLeader: action.payload || [],
        loading: false,
      };
    case Get_Sales_login_For_Assign_Leads_To_TeamLeaders_type:
      return {
        ...state,
        sales_Assign_Leads_To_hisTeamLeader: action.payload || [],
        loading: false,
      };

    case Get_All_Sales_Trash_type:
      return {
        ...state,
        salesTrash: action.payload || [],
        loading: false,
      };

    case Get_Error:
      return {
        ...state,
        error: action.payload || 'Unknown error',
        loading: false,
      };
    default:
      return state;
  }
};

export default Sales_Reducers;
